import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { FunctionComponentElement, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

import { useContactSupport } from '$components/chat-bot/useContactSupport';

export interface ErrorDialogProps {
  onTryAgain: () => void;
}

export function ErrorDialog({
  onTryAgain,
}: ErrorDialogProps): FunctionComponentElement<ErrorDialogProps> {
  const { t } = useTranslation();
  const handleContactSupport = useContactSupport();
  const closeButtonRef = useRef<null | HTMLButtonElement>(null);
  const tryAgainButtonRef = useRef<null | HTMLButtonElement>(null);

  useAutoFocus(closeButtonRef);
  return (
    <>
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="failed"
          className="bg-red-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>
          <Trans i18nKey="notificationRules.errorHeadline" />
        </Dialog.Title>
        <Trans i18nKey="notificationRules.editErrorMessage" />
        <p className="m-top-m">
          <span>{t('errors.contactSupport')} </span>
          <Dialog.Close>
            <button
              type="button"
              onClick={handleContactSupport}
              className="btn-as-link font-weight-regular color-blue-500"
            >
              {t('errors.contactSupport2')}
            </button>
          </Dialog.Close>
        </p>
      </div>
      <Dialog.Actions className="m-top-xxl">
        <Dialog.Close>
          <Button variant="secondary"> {t('shared.close')}</Button>
        </Dialog.Close>
        <Button ref={tryAgainButtonRef} onClick={onTryAgain} variant="primary">
          {t('shared.tryAgain')}
        </Button>
      </Dialog.Actions>
    </>
  );
}
